import { currentProjectName } from '@/config';
import clsx from 'clsx';
import styles from './Layout.module.scss';
import { LayoutProps } from './interfaces';

const Layout = ({
  children,
  variant = 'default',
  background = 'white',
  className,
  hasBorder,
  headerSlot,
  noFooterSpace,
  projectName = currentProjectName,
}: LayoutProps) => {
  const classes = [
    'base',
    styles[variant],
    styles[background],
    {
      [styles.hasBorder]:
        typeof hasBorder === 'undefined'
          ? variant === 'default' && background === 'white'
          : hasBorder,
    },
    className,
  ];

  const gradientStyle = {
    '--default-gradient': `var(--${projectName}-gradient)`,
  } as React.CSSProperties;

  return (
    <>
      {headerSlot && (
        <div
          className={clsx(styles.headerWrapper, ...classes)}
          style={gradientStyle}
        >
          {headerSlot}
        </div>
      )}
      <div
        data-layout-background={background}
        style={gradientStyle}
        className={clsx(styles.layout, ...classes)}
        {...(noFooterSpace && { 'data-no-footer-space': noFooterSpace })}
      >
        {children}
      </div>
    </>
  );
};

Layout.displayName = 'Layout';

export default Layout;
